import { FormControl, OutlinedInput, styled } from '@mui/material';

import { useEffect, useState } from 'react';

import { useDebounce } from '@app-velocity/common';

import { Typography } from '../..';

const StyledLabel = styled(Typography)(({ theme }) => ({
  color: 'var(--text-text-secondary-color)',
  fontSize: 12,
  lineHeight: 1.5,
  marginBottom: theme.spacing(1),
}));

const StyledFormControl = styled(FormControl)({
  width: '100%',
});

export type FilterTextFieldProps = {
  label: string;
  value: string;
  onChange: (value: string) => void;
  placeholder?: string;
};

export const FilterTextField = ({
  label,
  value,
  onChange,
  placeholder,
}: FilterTextFieldProps) => {
  const [localValue, setLocalValue] = useState(value);
  const debouncedValue = useDebounce(localValue, 700);

  useEffect(() => {
    setLocalValue(value);
  }, [value]);

  useEffect(() => {
    if (debouncedValue !== value) {
      onChange(debouncedValue);
    }
  }, [debouncedValue, value, onChange]);

  return (
    <StyledFormControl>
      <StyledLabel>{label}</StyledLabel>
      <OutlinedInput
        value={localValue}
        onChange={(event) => setLocalValue(event.target.value)}
        placeholder={placeholder}
        fullWidth
        size="small"
      />
    </StyledFormControl>
  );
};
